<div class="metadata-dialog" style="min-width: 300px !important;">
    <h2 mat-dialog-title>{{data.title}}</h2>

    <mat-dialog-content>
        <form #form="ngForm">
            <metadata-panel [ngModelGroup]="data.title" fxFill *ngIf="!loading" [model]="data.model"
                            [metadata]="data.metadata"></metadata-panel>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions fxLayout="column" fxLayoutAlign="center end">
        <forge-linear-progress *ngIf="loading"></forge-linear-progress>
        <command-bar [commands]="commands" attr.telemetry="Menu-{{data.title}}"></command-bar>
    </mat-dialog-actions>
</div>